function LightningThemeInit( )
{
    var path           = ( window.location.pathname || "" ).replace( /\/+$/, "" );
    var search         = window.location.search || "";
    var isQuiz         = ( path == "/pages/welleasy-quiz" );
    var isQuizsteps    = ( path == "/pages/membership-steps" && ( search.indexOf( "quizsteps=1" ) >= 0 || search.indexOf( "view=quizsteps" ) >= 0 || search.indexOf( "quizsteps" ) >= 0 ) );
    var fromCtaQuiz    = false;
    var skipToMembership = false;
    var shouldRedirect = false;

    try
    {
        fromCtaQuiz = ( sessionStorage.getItem( "cta_quiz_destination" ) == "1" );
    }
    catch ( e )
    {
    }

    if ( fromCtaQuiz )
    {
        try { sessionStorage.removeItem( "cta_quiz_destination" ); } catch ( e ) {}
        try { localStorage.removeItem( "skip_to_membership_page" ); } catch ( e ) {}
    }
    else
    {
        try
        {
            skipToMembership = Boolean( localStorage.getItem( "skip_to_membership_page" ) );
        }
        catch ( e )
        {
        }
        if ( skipToMembership )
        {
            try { localStorage.removeItem( "skip_to_membership_page" ); } catch ( e ) {}
            if ( !isQuiz )
            {
                shouldRedirect = true;
            }
        }
    }
    if ( shouldRedirect )
    {
        window.location.replace( "/pages/membership-steps?quizsteps=1" );
    }

    if ( isQuizsteps )
    {
        try { sessionStorage.removeItem( "we_register_flow" ); } catch ( e ) {}
    }
}

document.addEventListener( "DOMContentLoaded", LightningThemeInit );
